import http from "./http-service"

export default class CnpjBusca {

  static getDados(cnpj) {
    return http.get(`cnpjbusca/${cnpj}`)
  }
}